<template>
    <div class="CCollapse flex flex-col py-6">
        <div class="flex cursor-pointer flex-row" @click="isOpen = !isOpen">
            <div
                class="mr-4 flex size-6 shrink-0 items-center justify-center rounded-full leading-none lg:size-8"
                :class="isOpen ? 'bg-primary-500 text-white' : 'bg-primary-150 dark:bg-primary-950/40 text-primary-500'"
            >
                <svg
                    v-if="!isOpen"
                    aria-hidden="true"
                    class="h-3 w-3 lg:h-3.5 lg:w-3.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2.2"
                    viewBox="0 0 24 24"
                >
                    <path d="M12 5v14" />
                    <path d="M5 12h14" />
                </svg>
                <svg
                    v-else
                    aria-hidden="true"
                    class="h-3 w-3 lg:h-3.5 lg:w-3.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2.2"
                    viewBox="0 0 24 24"
                >
                    <path d="M5 12h14" />
                </svg>
            </div>

            <CText
                class="my-auto h-fit"
                :class="isOpen ? 'font-semibold' : ''"
                :variant="isOpen ? 'primary' : undefined"
            >
                <slot name="title" />
            </CText>
        </div>
        <transition name="collapse">
            <div v-if="isOpen" class="ml-10 mt-4 overflow-hidden text-sm text-gray-500 dark:text-txt-body lg:ml-12">
                <slot name="body" />
            </div>
        </transition>
    </div>
</template>

<script setup lang="ts">
import CText from '@/components/ui/CText.vue'
import { ref } from 'vue'

const isOpen = ref(false)
</script>

<style lang="postcss" scoped>
.collapse-enter-active,
.collapse-leave-active {
    transition: max-height 0.3s linear;
}

.collapse-enter-from,
.collapse-leave-to {
    max-height: 0;
    overflow: hidden;
}

.collapse-enter-to,
.collapse-leave-from {
    max-height: 500px;
    overflow: hidden;
}
</style>
